import React from 'react';
import PriceDisplay from './priceDisplay';

const RadioGroup = ({ onChange, items, name }) => {
    return (
        <div className="option-list columns is-multiline is-mobile">
            {
                items.map((item, index) => {
                    return (
                        <div key={`${name}-${index}`}  className="column is-half-mobile     is-one-quarter-tablet">
                            <label className="card card-option">
                                    <input type="radio" defaultChecked={ item.selected || false }  value={item.title} name={name} onChange={ () => onChange(item, name) }/>
                                    <div className="card-content has-text-centered">
                                        <div className="card-option__image">
                                            <img src="https://placehold.it/150" alt=""/>
                                        </div>
                                        <strong>
                                            { item.title }
                                        </strong>
                                        {
                                            item.description &&
                                                <span>
                                                    <br/>
                                                    <small>
                                                        {item.description}
                                                    </small>
                                                </span>
                                        }
                                        <div className="price-tag">
                                            <PriceDisplay price={item.price} />
                                        </div>
                                    </div>
                            </label>

                        </div>
                    )
                })
            }
        </div>
    )
};

export default RadioGroup;


// WEBPACK FOOTER //
// ./src/components/reservationForm/radioGroup.js